import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType, ResponseOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/Observable/throw';
import 'rxjs/add/operator/toPromise';
import { global } from '../../models/global';
import { workerAddressDetails } from '../../Models/Admin/worker-address';


@Injectable({
  providedIn : 'root'
})
export class WorkerAddressService {

  ROOT_URL : string = "";
    constructor(private http : Http) {
        let g: global = new global();
        this.ROOT_URL = g.getApiUrl();
    }

    getWorkerDetail(workerAddress:workerAddressDetails) : Observable<any> {
      let _body = {
        "ACTION": workerAddress.action,
        "ID": workerAddress.id,
        "USERNAME": workerAddress.username,
        "USERID": workerAddress.userid,
        "DESIGNATION": workerAddress.designation,
        "StreetAddress": workerAddress.streetAddress,
        "City": workerAddress.city,
        "PINCODE": workerAddress.pincode,
        "STATE": workerAddress.state,
        "LoggedInUser": localStorage.getItem('mcmt_userId')
    }


    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
    let requestoptions: RequestOptions = new RequestOptions({
        method: 'POST',
        url: this.ROOT_URL + "/api/WorkerAddress/GetWorkerAddressDetails",
        headers: headers,
        body: _body
    })

    return this.http.request(new Request(requestoptions))
        .map((res: Response) => {
            return res.json();
        });
  }

  DownloadWorkerAddressExcel(): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
    let requestoptions: RequestOptions = new RequestOptions({
        method: 'POST',
        url: this.ROOT_URL + "/api/WorkerAddress/DownloadworkerAddressExcel?userId=" + localStorage.getItem('mcmt_userId'),
        headers: headers,
        responseType: ResponseContentType.Blob,
    })
    return this.http.request(new Request(requestoptions))
        .map((res: Response) => {
            var blob = new Blob([res.blob()], { type: 'xlsx' })
            return blob;
        });
}
getworkerFilter()
{
  let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
  let requestoptions: RequestOptions = new RequestOptions({
      method: 'GET',
      url: this.ROOT_URL + "/api/WorkerAddress/getworkerFilter",
      headers: headers
  })

  return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
          return res.json();
      });
}
UploadWorkerAddressExcel(fileList: any): Observable<any> {
  let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
  let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/WorkerAddress/UploadWorkerAddressExcel?userid="+localStorage.getItem('mcmt_userId'),
      headers: headers,
      body: fileList,
      responseType: ResponseContentType.Json
  })
  return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
          return res.json();
      });
}
  // UpdateWorkerDetail() : Observable<any> {
  //   let _body = {
  //       "UserID" : localStorage.getItem('mcmt_userId'),
  //       "Data" : jobList
  //     }
  //   let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
  //   let requestoptions : RequestOptions = new RequestOptions({
  //       method : 'POST',
  //       url : this.ROOT_URL + "/api/JobSpecification/UpdateJobSpecification",
  //       headers : headers,
  //       body : _body
  //   })
    
  //   return this.http.request(new Request(requestoptions))
  //       .map((res : Response) => {
  //           return res.json();
  //       });

  // }
}
